import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

/** Tighter viewBox so the path fills the icon area (content spans ~4–22 x, ~5–18 y) */
const VIEW_BOX = '2 2 20 18';

export default function MediaPersonIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox={VIEW_BOX}>
      <path d="M5.5 5C4.67 5 4 5.67 4 6.5v8c0 .83.67 1.5 1.5 1.5h6.46c.29-.57.67-1.09 1.12-1.54.44-.43.95-.79 1.52-1.06V6.5C14.6 5.67 13.93 5 13.1 5H5.5zm.5 2h6.6v6H6V7zm2.1.85v4.3l3.45-2.15L8.1 7.85zM17.2 11.1c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5zm0 6c-2.08 0-4.38 1.03-5.05 2.9-.1.28.11.58.41.58h9.27c.3 0 .51-.3.41-.58-.67-1.87-2.97-2.9-5.04-2.9z" />
    </SvgIcon>
  );
}
